/**
 * Created by d.penning on 06.10.2017.
 */
import * as actions from '../actions/actionTypes'
import { IPlayerStatsState, IState } from '../store/state';

const playerStats = (state : IPlayerStatsState = {}, action: any) : IPlayerStatsState => {
    switch (action.type) {
        case actions.FETCH_PLAYER_STATS_SUCCEEDED:
            return Object.assign({}, state, action.payload.doc[0].data.team)
        default:
            return state
    }
}

export const getPlayerStats = (state:IState) => {
  // return Object.keys(state.playerStats).map(id => state.playerStats[id])
  return state.playerStats
}

export default playerStats
